import { render, staticRenderFns } from "./delete-config-tab.vue?vue&type=template&id=30ece221&scoped=true"
import script from "./delete-config-tab.vue?vue&type=script&lang=js"
export * from "./delete-config-tab.vue?vue&type=script&lang=js"
import style0 from "./delete-config-tab.vue?vue&type=style&index=0&id=30ece221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ece221",
  null
  
)

export default component.exports